module.exports = __webpack_public_path__ + "static/img/car_6.09b8a81.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/car_6.png
// module id = gB3B
// module chunks = 1